export function entityTypeFields(entityType) {
    if (entityType?.schema_version >= 2) return (entityType.schema_custom_meta_fields || []).map(field => ({
        ...field,
        required: !!field.required || !!entityType.fields?.find(entry => entry.custom_meta_field_id === field.id)?.required
    }));
    const fields = [];
    const ids = new Set();
    const addField = field => {
        if (!field || ids.has(field.id)) return;
        ids.add(field.id);
        fields.push(field);
    };

    entityType?.custom_meta_groups?.forEach(groupMembership => {
        groupMembership.custom_meta_group?.custom_meta_fields?.forEach(fieldMembership => {
            addField(fieldMembership.custom_meta_field);
        });
    });

    entityType?.custom_meta_fields?.forEach(fieldMembership => {
        addField(fieldMembership.custom_meta_field);
    });

    return fields;
}

export function normalizeEntityAssetFormValues(values, entityType) {
    const fieldsById = new Map(entityTypeFields(entityType).map(field => [field.id.toString(), field]));
    const customMeta = Object.entries(values.custom_meta || {}).reduce((attrs, [fieldId, value]) => {
        attrs[fieldId] = normalizeCustomMetaValue(value, fieldsById.get(fieldId));
        return attrs;
    }, {});

    return {
        ...values,
        custom_meta: customMeta,
        standard_meta: Object.fromEntries(Object.entries(values.standard_meta || {}).map(([key, value]) => [key, normalizeCustomMetaValue(value, entityType?.fields?.find(field => field.standard_field_key === key))]))
    };
}

export function entityAssetFormHasRequiredValues(values, entityType) {
    const sourceValue = (key, input) => {
        const binding = entityType?.display_config?.[key];
        if (!binding || binding === 'input') return values?.[input];
        const [kind, field] = binding.split(':');
        return values?.[kind === 'custom' ? 'custom_meta' : 'standard_meta']?.[field];
    };
    if (!hasFormValue(sourceValue('filename_source', 'filename'))) return false;
    if (entityType?.schema_version >= 2 && !hasFormValue(sourceValue('display_title_source', 'display_title'))) return false;
    if (entityType?.fields?.some(field => field.standard_field_key && field.required && !hasFormValue(values?.standard_meta?.[field.standard_field_key]))) return false;

    return entityTypeFields(entityType)
        .filter(field => field.required)
        .every(field => hasFormValue(values?.custom_meta?.[field.id.toString()]));
}

function normalizeCustomMetaValue(value, field) {
    if (Array.isArray(value)) return value.map(item => normalizeCustomMetaValue(item, field)).filter(item => item !== null && item !== undefined && item !== "");
    if (value === null || value === undefined || value === "") return value;

    if (value?.format) {
        if (field?.value_type === "date") return value.format("YYYY-MM-DD");
        if (field?.value_type === "datetime") return value.toISOString ? value.toISOString() : value.format();
    }

    return value;
}

function hasFormValue(value) {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "string") return value.trim().length > 0;

    return value !== null && value !== undefined && value !== "";
}
